export class Session {
    /**
     * @public {string}
     */
    sessionId;
    /**
     * @public {string}
     */
    refreshToken;
    /**
     * @public {string}
     */
    url;
    /**
     * {string}
     */
    language;

    /**
     * {number}
     */
    userId;

    /**
     * {string}
     */
    app;

    constructor(data) {
        Object.assign(this, data);
        if (this.userId) {
            this.userId = parseInt(this.userId);
        }
    }
}